import { isDateFuture } from '../../../../utils/dateFunctions';
import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    getNowDateOrEarlierMessage,
    getReqMessage,
    getValueRangeMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

export const MIN_STEPS = 1;
export const MAX_STEPS = '9,999,999,999';

export const validate = (newEntry, formType, initialEntry) => {
    let newErrors = {};

    if (!newEntry.value) {
        newErrors = {
            ...newErrors,
            value: { error: true, message: getReqMessage('Steps value') }
        };
    } else if (+newEntry.value < 1) {
        newErrors = {
            ...newErrors,
            value: { error: true, message: getValueRangeMessage(MIN_STEPS, MAX_STEPS) }
        };
    }

    if (!newEntry.date) {
        newErrors = {
            ...newErrors,
            date: { error: true, message: getReqMessage('Date') }
        };
    } else if (isDateFuture(newEntry.date)) {
        newErrors = {
            ...newErrors,
            date: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    if (Object.keys(newErrors).length < 1 && formType === 'edit') {
        newErrors = checkDiff(newEntry, initialEntry);
    }

    return newErrors;
};
